import { useSelector } from 'react-redux';
import BtnOptions from './BtnOptions';
import ModuleSelect from '../../../../components/form/Selects/ModuleSelect';

export default function Report53Options({
  handleOnSetFieldValue,
  handleOnSubmit,
  handleOnSave,
  values,
}) {
  const auth = useSelector((state) => state.auth);

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <ModuleSelect
            type="client"
            moduleType="LegalCompliance"
            value={values.module}
            onChange={(opt) => handleOnSetFieldValue('module', opt)}
            isMulti={false}
            clientIDs={[auth.user?.client?.id]}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={!values.module}
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
}
